import React from 'react';
import { Grid, Card } from 'semantic-ui-react';
import { ExtendedDocuments } from '../Documents';
import FNButtons from './FNButtons';

const filterAirRefundDocuments = [
  'Documents::Undefined',
  'Documents::FirstLetter',
  'Documents::AutomaticFormalNotice',
  'Documents::LegalFormalNotice',
  'Documents::AmicableAirlineAnswer'
];

const AirRefundAttachments = ({ navButtonsProps, ...rest }) => (
  <React.Fragment>
    <Card.Description>
      <Grid>
        <Grid.Row>
          <Grid.Column width={16}>
            <ExtendedDocuments
              editDisabled={false}
              defaultSelectedDocumentTypes={['Documents::LegalFormalNotice']}
              documentsName="selectedAirRefundDocuments"
              filterTypes={filterAirRefundDocuments}
              disableCropping
              {...rest}
            />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </Card.Description>
    <FNButtons {...navButtonsProps} />
  </React.Fragment>
);

export default AirRefundAttachments;



// WEBPACK FOOTER //
// ./src/component/TaskCreator/AirRefundAttachments.js